module.exports = __webpack_public_path__ + "static/media/18.31562822.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/18.jpg
// module id = 477
// module chunks = 0